import {Flex, Text} from '@chakra-ui/react'
import {updateIsPauseAudio, updateTabValue} from '@redux/exam-result/examResult'
import {useDispatch, useSelector} from 'react-redux'
const tab = [
  {
    label: 'Trôi chảy và Phát âm',
    value: 1,
  },
  {
    label: 'Từ vựng và Ngữ pháp',
    value: 2,
  },
]

const Tabs = () => {
  const {tabValue} = useSelector((state: any) => state.examResult)
  const dispatch = useDispatch()

  const handleClickTab = (value: any) => {
    dispatch(updateTabValue(value))
    dispatch(updateIsPauseAudio(true))
  }

  return (
    <Flex px={{base: '16px', md: '20px'}} gap={{base: '12px', md: '16px'}}>
      {tab.map((item: any, index: any) => {
        return (
          <Text
            key={index}
            flex={1}
            align={'center'}
            fontSize={{base: '14px', md: '16px'}}
            fontWeight={700}
            borderRadius={'16px 16px 0px 0px'}
            p={{base: '12px', md: '16px'}}
            bg={item.value === tabValue ? 'white' : '#F0F0F0'}
            cursor={'pointer'}
            transition={'0.3s'}
            onClick={() => handleClickTab(item.value)}>
            {item.label}
          </Text>
        )
      })}
    </Flex>
  )
}

export default Tabs
